document.addEventListener('DOMContentLoaded', () => {
  const eighteen_plus = document.querySelector('.product-form__item--age-restriction input[type="checkbox"]');
  const dummy_button = document.querySelector('.product-form .addtocart-wishlist .product-form__item--age-_btn');
  const buy_button = document.querySelector('.product-form .addtocart-wishlist .product-form__submit');
  const age_restriction_wrap = document.querySelector('.product-form__item--age-restriction .input-wrapper');

  function flash(elements, color = '255, 255, 136', duration = 2000) {
    let opacity = 100;

    const interval = setInterval(() => {
      opacity -= 2.5;
      if (opacity <= 0) {
        clearInterval(interval);
        return;
      }

      $(elements).css({
        background: `rgba(${color}, ${opacity / 100})`
      });
    }, duration / 40);
  }

  if(dummy_button){
      dummy_button.addEventListener('click', () => {
        dummy_button.querySelector('.atc_txT_wrapper[data-add-to-cart-text]')?.classList.add('bt-shake');
        setTimeout(() => {
          dummy_button.querySelector('.atc_txT_wrapper[data-add-to-cart-text]')?.classList.remove('bt-shake');
        }, 1000);

        flash(age_restriction_wrap);
      })
  }

  function toggleButtons() {
    if (eighteen_plus?.checked && dummy_button && buy_button) {
      dummy_button.classList.add('hidden');
      buy_button.classList.remove('hidden');
    } else {
      dummy_button?.classList.remove('hidden');
      buy_button?.classList.add('hidden');
    }
  }
  // toggleButtons();
  eighteen_plus?.addEventListener('change', toggleButtons);

  window.addEventListener("pageshow", () => {
    if (eighteen_plus) {
      eighteen_plus.checked = false;
      eighteen_plus.dispatchEvent(new Event("change")); // re-trigger toggle logic if needed
    }
  });
});



// $(document).ready(function() {
//   var swiper = new Swiper(".gallery-slider", {
//     slidesPerView: 1,
//     spaceBetween: 10,
//     centeredSlides: true,
//     loop: true
//   });
  
// });

function initGallerySwiper() {
  document.querySelectorAll(".gallery-slider").forEach((slider) => {
    
    // ✅ Skip if already initialized
    if (slider.classList.contains("swiper-initialized")) return;

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      observer: true,
      observeParents: true
    });
  });
}

let timeout;

const galleryObserver = new MutationObserver(() => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    initGallerySwiper();
  }, 100);
});

galleryObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// // console.log(window.storeLocator());

// // window.theme = window.theme || {};


// window.theme = window.theme || {};

// theme.StoreLocator = (function () {
//   var selectors = {
//     storeLocationData: '[data-store-locator-json]',
//     storeLocatorTriggerLinks: 'a[href="#store-locator"], a[href="#storelocator"]',
//   };
//   var cache = {
//     lightboxCreated: false,
//   };

//   if (!theme.shop || !$(selectors.storeLocationData).length) {
//     return;
//   }

//   var storeLocations = JSON.parse($(selectors.storeLocationData).html());
//   $.extend(theme.shop.locations, storeLocations);
//   theme.shop.locations['count'] = Object.keys(storeLocations).length;

//   if (!theme.shop.locations && google !== undefined && google.maps !== undefined) {
//     return;
//   }

//   // theme.shop.locationsByGroup = {};
//   // _.each(storeLocations, function (location, key) {
//   //   theme.shop.locationsByGroup[location.group] = theme.shop.locationsByGroup[location.group] || {};
//   //   theme.shop.locationsByGroup[location.group][key] = location;
//   // });

//   // if (Cookies !== undefined) {
//   //   theme.shop.locations.favourite = Cookies.get('storeLocation') || false;
//   // }

//   // rivets.formatters.replace = function (a,b,c) {
//   //   return a.replace(b,c);
//   // }

//   // rivets.formatters.storeTitle = function (storeCode) {
//   //   var storeTitle;
//   //   if (storeCode !== undefined && storeCode) {
//   //     storeCode = storeCode.replace(' ', '_');
//   //   }
//   //   if (theme.shop.locations !== undefined && theme.shop.locations[storeCode] !== undefined) {
//   //     storeTitle = theme.shop.locations[storeCode].title;
//   //   } else {
//   //     storeTitle = '';
//   //   }

//   //   return storeTitle;
//   // };

//   // $(selectors.storeLocatorTriggerLinks).on('click', function (evt) {
//   //   evt.preventDefault();
//   //   theme.StoreLocator.open();
//   // });

//   // rivets.formatters.clickCollectStoreEnabled = function (storeCode) {
//   //   if (storeCode !== undefined && storeCode) {
//   //     storeCode = storeCode.replace(' ', '_');
   

//   //     if (theme.shop.locations !== undefined && theme.shop.locations[storeCode] !== undefined && theme.current.variant.inventory_details && theme.current.variant.inventory_details[storeCode] !== undefined && theme.current.variant.inventory_details[storeCode] > 0) {
//   //       return true;
//   //     }
//   //   }
//   //   $(`li[data-location='${storeCode}']`).addClass('hide-li');
//   //   return false;
//   // };

//   // rivets.formatters.telLink = function (phone) {
//   //   return '<a href="tel:' + phone.split(' ').join('').replace('(', '').replace(')', '') + '">' + phone + '</a>';
//   // };

//   // rivets.formatters.get = function (t, e) {
//   //   return t[e];
//   // };

//   // rivets.formatters.log = function (a) {
//   //   console.log(a);
//   //   return a;
//   // };

//   $(selectors.storeLocatorTriggerLinks).on('click', function (evt) {
//     evt.preventDefault();
//     // $('html').addClass('no-scroll');
//     theme.StoreLocator.open();
//   });

//   function open() {
//     if (cache.lightboxCreated) {
//       cache.lightbox.open();
//     } else {
//       cache.lightbox = $.featherlight($('[data-store-locator-content]'), {
//         namespace: 'od-modal',
//         variant: 'od-modal--store-locator',
//         persist: true,
//         afterContent: function () {
//           if (!cache.lightboxCreated) {
//             var $container = $('.row', this.$content);
//             $container.css('height', this.$content.innerHeight());

//             var map = initStoreLocator(this.$content, 10, true);

//             cache.lightboxCreated = true;
//           }
//         },
//         beforeOpen: function () {
//           $(document.documentElement).addClass('with-featherlight');
//         },
//         afterClose: function () {
//           $(document.documentElement).removeClass('with-featherlight');
//           if (!theme.shop.locations.favourite) {
//             theme.shop.clickAndCollect.selected = "";
//             $('#shippingMethod-delivery').trigger('change');
//           }
//         }
//       });
//     }
//   }

//   /**
//    * Initialises the store locator inside given container
//    */
//   function initStoreLocator($container, visibleStoreLimit, sortByDistance, dataObject, geolocationEnabled, autocompleteOptions) {
//     cache.map = new google.maps.Map($('#store-locator-map-canvas', $container).get(0), {
//       center: new google.maps.LatLng(-28, 135),
//       zoom: 4,
//       mapTypeId: google.maps.MapTypeId.ROADMAP,
//       styles: [{ "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#004343" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#dae3e3" }] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#e3eded" }] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#d1e4e4" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#004343" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "lightness": 100 }, { "visibility": "simplified" }] }, { "featureType": "road", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry.fill", "stylers": [{ "color": "#dee1e1" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "visibility": "on" }, { "lightness": 700 }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#bfe0e0" }] }]
//     });

//     var storeData = theme.shop.locations;
//     if (dataObject && dataObject != undefined) {
//       storeData = dataObject;
//     }

//     var data = new StoreLocatorDataSource(storeData);

//     var view = new storeLocator.View(cache.map, data, {
//       geolocation: false,
//       features: data.getFeatures(),
//       markerIcon: theme.default.mapMarkerIcon,
//     });

//     google.maps.event.addListener(view, 'selectedStore_changed', function (evt) {
//       if (evt != null && evt.id_ !== undefined) {
//         // check if you are on the store locator page 
//         if ($(window).width() < 767 && $container.is('#MainContent .store-locator')) {
//           window.location.href = theme.shop.locations[evt.id_].url;
//         } else {
//           $(`.store-list li.store.highlighted`).removeClass('highlighted');
//           $(`.store-list li.store#store-${evt.id_}`).addClass('highlighted');
//           $container.addClass('store-locator--actions-enabled').attr('data-selected-store', evt.id_);
//           $('[data-store-locator-content]').addClass('store-locator--actions-enabled').attr('data-selected-store', evt.id_);
//           $container.find('#store-locator-actions a').attr('href', theme.shop.locations[evt.id_].url);
//           $container.find('#store-locator-actions-popup a').attr('href', theme.shop.locations[evt.id_].url);
//         }
//       }
//     });

//     if (autocompleteOptions === undefined) {
//       autocompleteOptions = {
//         types: ['(regions)'],
//         componentRestrictions: {
//           country: 'au'
//         }
//       };
//     }

//     cache.storeLocator = new storeLocator.Panel($('#store-locator-panel', $container).get(0), {
//       view: view,
//       maxPanelListings: visibleStoreLimit,
//       autocomplete: autocompleteOptions
//     });

//     if (geolocationEnabled === undefined) {
//       geolocationEnabled = true;
//     }

//     if (geolocationEnabled && "geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         cache.map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
//         cache.map.setZoom(12);
//         var geocoder = new google.maps.Geocoder();
//         geocoder.geocode({
//           'latLng': { lat: position.coords.latitude, lng: position.coords.longitude }
//         }, function (results, status) {
//           if (status == google.maps.GeocoderStatus.OK) {
//             if (results[0]) {
//               var city = $.grep(results[0].address_components, function (x) {
//                 return $.inArray('locality', x.types) != -1;
//               })[0].short_name;

//               var state = $.grep(results[0].address_components, function (x) {
//                 return $.inArray('administrative_area_level_1', x.types) != -1;
//               })[0].short_name;

//               $('.location-search input', $container).val(city + ', ' + state);
//             }
//           }
//         });
//       });
//     }

//     var $list = $('#store-locator-list', $container),
//       locationDetails = [],
//       groupSortExceptions = { "Victoria": 1 };

//     if ($list.length) {
//       for (var key in theme.shop.locations) {
//         if (theme.shop.locations.hasOwnProperty(key)) {
//           if (theme.shop.locations[key].title !== undefined) {
//             locationDetails.push({
//               group: theme.shop.locations[key].group,
//               title: theme.shop.locations[key].title,
//               content: '<li class=""><a href="#" data-location="' + key + '" data-url="' + theme.shop.locations[key].url + '">' + theme.shop.locations[key].title + '</a></li>',
//             });
//           }
//         }
//       }

//       locationDetails.sort(function (a, b) { return a.title - b.title; });
//       locationDetails.sort(function (a, b) {
//         if (groupSortExceptions[a.group] && groupSortExceptions[b.group]) {
//           return groupSortExceptions[a.group] - groupSortExceptions[b.group];
//         } else if (groupSortExceptions[a.group]) {
//           return -1;
//         } else if (groupSortExceptions[b.group]) {
//           return 1;
//         } else {
//           return a.group.localeCompare(b.group);
//         }
//       });

//       var appendString = '', currentGroup, prevGroup = false;
//       for (var i = 0; i < locationDetails.length; i++) {
//         currentGroup = locationDetails[i].group;
//         if (currentGroup != prevGroup) {
//           if (prevGroup !== false) appendString += '</ul>';
//           appendString += '<h4 data-toggle-self data-toggle=".store-group-' + theme.utils.handleize(currentGroup) + '"';
//           if (i == 0) appendString += ' class="active"';
//           appendString += '>' + currentGroup + '</h4><ul class="';
//           if (prevGroup === false) appendString += 'active ';
//           appendString += 'store-group-' + theme.utils.handleize(currentGroup) + '">';
//         }
//         appendString += locationDetails[i].content;
//         if (i == locationDetails.length - 1) {
//           appendString += '</ul>';
//         }
//         prevGroup = currentGroup;
//       }

//       $list.append(appendString);
//     }

//     $('.store-locator__set-default', $container).on('click', function () {
//       var selectedStore = $container.attr('data-selected-store');
//       Cookies.set('storeLocation', selectedStore);
//       theme.shop.locations.favourite = selectedStore;

//       var $selectedShippingType = $('.cart-drawer__shipping input[type="radio"]:checked');
//       if ($selectedShippingType.length) {
//         $selectedShippingType.trigger({
//           type: 'change',
//           store: selectedStore
//         });
//       }

//       cache.lightbox.close();

//       // Trigger product variant change to update location inventory
//       $('[data-section-type="product"]').trigger({
//         type: 'variantChange',
//         variant: theme.current.variant
//       });

//       // $('#shippingMethod-click_collect').trigger({
//       //   type: 'change',
//       //   store: selectedStore
//       // });
//     });

//     return cache.map;
//   }

//   /**
//    * @extends storeLocator.StaticDataFeed
//    * @constructor
//    */
//   function StoreLocatorDataSource(storeData) {
//     $.extend(this, new storeLocator.StaticDataFeed());
//     this.setStores(this.parse_(storeData));

//   }

//   /**
//    * @const
//    * @type {!storeLocator.FeatureSet}
//    * @private
//    */
//   StoreLocatorDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
//     // new storeLocator.Feature('Wheelchair-YES', 'Wheelchair access'),
//     // new storeLocator.Feature('Audio-YES', 'Audio')
//   );

//   /**
//    * @return {!storeLocator.FeatureSet}
//    */
//   StoreLocatorDataSource.prototype.getFeatures = function () {
//     return this.FEATURES_;
//   };

//   /**
//    * @private
//    * @param {string} csv
//    * @return {!Array.<!storeLocator.Store>}
//    */
//   StoreLocatorDataSource.prototype.parse_ = function (data) {
//     var stores = [];

//     for (var key in data) {
//       if (data.hasOwnProperty(key)) {
//         if (data[key].lat !== undefined && data[key].long !== undefined) {
//           var features = new storeLocator.FeatureSet();

//           var position = new google.maps.LatLng(data[key].lat, data[key].long);

//           var store = new storeLocator.Store(key, position, features, {
//             title: data[key].title,
//             address: data[key].address,
//             hours: data[key].hours
//           });

//           stores.push(store);
//         }
//       }
//     }

//     return stores;
//   };

//   /**
//    * Joins elements of an array that are non-empty and non-null.
//    * @private
//    * @param {!Array} arr array of elements to join.
//    * @param {string} sep the separator.
//    * @return {string}
//    */
//   StoreLocatorDataSource.prototype.join_ = function (arr, sep) {
//     var parts = [];
//     for (var i = 0, ii = arr.length; i < ii; i++) {
//       arr[i] && parts.push(arr[i]);
//     }
//     return parts.join(sep);
//   };

//   /**
//    * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
//    * IMPORTANT: Don't use this for general CSV parsing!
//    * @private
//    * @param {string} row
//    * @return {Array.<string>}
//    */
//   StoreLocatorDataSource.prototype.parseRow_ = function (row) {
//     // Strip leading quote.
//     if (row.charAt(0) == '"') {
//       row = row.substring(1);
//     }
//     // Strip trailing quote. There seems to be a character between the last quote
//     // and the line ending, hence 2 instead of 1.
//     if (row.charAt(row.length - 2) == '"') {
//       row = row.substring(0, row.length - 2);
//     }

//     row = row.split('","');

//     return row;
//   };

//   /**
//    * Creates an object mapping headings to row elements.
//    * @private
//    * @param {Array.<string>} headings
//    * @param {Array.<string>} row
//    * @return {Object}
//    */
//   StoreLocatorDataSource.prototype.toObject_ = function (headings, row) {
//     var result = {};
//     for (var i = 0, ii = row.length; i < ii; i++) {
//       result[headings[i]] = row[i];
//     }
//     return result;
//   };

//   $('body').on('click', '.storelocator-panel-popup .store', function(evt) {
//     $('.storelocator-panel-popup').animate({scrollTop: $('.storelocator-panel-popup .storelocator-filter').offset().top-150}, 350);
//   });

//   return {
//     open: open,
//     init: initStoreLocator,
//   };

// })();


// var $locationList = $('[data-locations-list]');
//   if ($locationList.length && theme.shop.locations !== undefined) {
//     $locationList.each(function () {
//       var $list = $(this);

//       for (var key in theme.shop.locations) {
//         if (theme.shop.locations.hasOwnProperty(key)) {
//           if (theme.shop.locations[key].title !== undefined) {
//             $list.append('<li><a href="' + theme.shop.locations[key].url + '">' + theme.shop.locations[key].title + '</a></li>');
//           }
//         }
//       }

//       $list.children().detach().sort(function (a, b) {
//         return $(a).text().localeCompare($(b).text());
//       }).appendTo($list);
//     });
//   }



// Brands page start
$(document).ready(function(){
  var swiper = new Swiper(".nav-slider", {
    spaceBetween: 10,
    slidesPerView: 7,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
    600: {
      slidesPerView: 15,
      spaceBetween: 13,
      centeredSlides: false
    },
    900: {
      slidesPerView: 20,
      spaceBetween: 13,
      centeredSlides: false
    },
    1200: {
      slidesPerView: 27,
      spaceBetween: 13,
      centeredSlides: false
    }
  }
  });
  var swiper2 = new Swiper(".brands-slider", {
    spaceBetween: 10,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    thumbs: {
      swiper: swiper,
    },
  });
});




let totalCount = 0;
$('.brands-list').each(function() {
  totalCount += $(this).children().length;
});
// $('.brands-count span').text(`${totalCount}`);

 

$(document).ready(function(){
    // Get element references
    let announc = document.querySelector('.announcement-bar-section');
    let header = document.querySelector('.section-header');
    let brandNav = document.querySelector('.brands-nav-sticky');

    // Calculate total height of announcement bar and header
    let total = announc.offsetHeight + header.offsetHeight + brandNav.offsetHeight;
  
	var contentSection = $('.brands');
	var navigation = $('.nav');
	
	//when a nav link is clicked, smooth scroll to the section
	navigation.on('click', 'a', function(event){
		event.preventDefault(); //prevents previous event
      if($(this.hash).length){
		smoothScroll($(this.hash));
      }
	});
  
  	function smoothScroll(target){
        const mediaQuery = window.matchMedia('(max-width: 748px)');
        if (mediaQuery.matches) {
           $('body,html').animate({
      			scrollTop: target.offset().top - total + 30
           }, 800);
 
        } else {
          $('body,html').animate({
  			scrollTop: target.offset().top - total + 40
  		}, 800);
        }  
	}
});

document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll(".brands-nav .nav a");
    const nav = document.querySelector(".brands-nav .nav");

    // Create a map of valid sections and their corresponding navigation links
    const validNavLinks = [];
    const validSections = [];

    navLinks.forEach((link) => {
        const targetId = link.getAttribute("href");
        const correspondingSection = document.querySelector(targetId);

        if (correspondingSection) {
            validNavLinks.push(link);
            validSections.push(correspondingSection);
        } else {
            // Add a class to indicate the section is missing
            link.classList.add("section-missing");
        }
    });

    function highlightNav() {
        let activeSectionIndex = null;

        // Find the section that is 90% beyond the navigation bar
        validSections.forEach((section, index) => {
            const rect = section.getBoundingClientRect();
            const navRect = nav.getBoundingClientRect();

            // Check if the section is 90% beyond the navigation bar
            if (rect.top <= navRect.bottom * 1.3) {
                activeSectionIndex = index;
            }
        });

        // Remove active class from all valid links
        validNavLinks.forEach((link) => link.classList.remove("active-section"));

        // Add active class to the next valid section's link
        if (activeSectionIndex !== null && activeSectionIndex < validNavLinks.length) {
            const activeLink = validNavLinks[activeSectionIndex];

            // Ensure the active link exists
            if (activeLink) {
                activeLink.classList.add("active-section");

                // Scroll the navigation to keep the active link in view
                const navRect = nav.getBoundingClientRect();
                const linkRect = activeLink.getBoundingClientRect();

                if (linkRect.left < navRect.left) {
                    nav.scrollBy({
                        left: linkRect.left - navRect.left - 10, // Adjust offset as needed
                        behavior: "smooth",
                    });
                } else if (linkRect.right > navRect.right) {
                    nav.scrollBy({
                        left: linkRect.right - navRect.right + 10, // Adjust offset as needed
                        behavior: "smooth",
                    });
                }
            }
        }

        // Handle the #hash section separately if it's at the top
        const hashSection = document.querySelector("#hash");
        if (hashSection) {
            const hashRect = hashSection.getBoundingClientRect();
            if (hashRect.top >= 0 && hashRect.bottom <= window.innerHeight) {
                // If the #hash section is in view, activate its link
                const hashLink = document.querySelector('.nav a[href="#hash"]');
                if (hashLink) {
                    // Remove active class from all other links
                    validNavLinks.forEach((link) => link.classList.remove("active-section"));
                    // Add active class to the #hash link
                    hashLink.classList.add("active-section");
                }
            }
        }
    }

    // Highlight on scroll
    window.addEventListener("scroll", highlightNav);

    // Highlight on page load
    highlightNav();
});
// Brands page end


// price filter start
function initPriceSlider() {

  document.querySelectorAll(".price-filter").forEach((wrap) => {

    const minSlider = wrap.querySelector(".range-min");
    const maxSlider = wrap.querySelector(".range-max");

    const minInput = wrap.querySelector(".min-input");
    const maxInput = wrap.querySelector(".max-input");

    const track = wrap.querySelector(".range-track");

    if (!minSlider || !maxSlider || !track) return; // safety

    const max = parseFloat(maxSlider.max);

    // INIT
    const minInit = parseFloat(minInput.value);
    const maxInit = parseFloat(maxInput.value);

    minSlider.value = !isNaN(minInit) ? minInit : 0;
    maxSlider.value = !isNaN(maxInit) ? maxInit : max;

    function updateTrack() {
      const minVal = parseFloat(minSlider.value) || 0;
      const maxVal = parseFloat(maxSlider.value) || max;

      const left = (minVal / max) * 100;
      const width = ((maxVal - minVal) / max) * 100;

      track.style.left = left + "%";
      track.style.width = width + "%";
    }

    function applyFilter() {
      const form = wrap.closest("form");
      if (form) {
        form.dispatchEvent(new Event("submit", { bubbles: true }));
      }
    }

    function syncInputs() {
      minInput.value = minSlider.value;
      maxInput.value = maxSlider.value;
      applyFilter();
    }

    // 🔥 REMOVE OLD EVENTS (IMPORTANT)
    minSlider.oninput = null;
    maxSlider.oninput = null;

    minSlider.addEventListener("input", () => {
      if (+minSlider.value >= +maxSlider.value) {
        minSlider.value = maxSlider.value - 1;
      }
      syncInputs();
      updateTrack();
    });

    maxSlider.addEventListener("input", () => {
      if (+maxSlider.value <= +minSlider.value) {
        maxSlider.value = +minSlider.value + 1;
      }
      syncInputs();
      updateTrack();
    });

    updateTrack();
  });

}

// FIRST LOAD
document.addEventListener("DOMContentLoaded", initPriceSlider);

document.addEventListener("shopify:section:load", function () {
  initPriceSlider();
});

const observer = new MutationObserver(() => {
  initPriceSlider();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
// price filter end


(function () {
  var css = `
    div.px-2 { display: none !important; }
    div.absolute { display: none !important; }
    button { background: transparent !important; background-color: transparent !important; box-shadow: none !important; border: none !important; }
    button.h-9 { height: auto; padding: 10px 0; }
    span.cursor-pointer { font-size: 0 !important; line-height: 0; }
    span.cursor-pointer svg { display: inline-block !important; width: 26px !important; height: auto !important; color: #000000 !important; }
  `;

  function applyFix() {
    document.querySelectorAll('shop-follow-button').forEach(function (sfb) {
      var shadow = sfb.shadowRoot;
      if (!shadow || shadow.querySelector('#sfb-fix')) return;
      var style = document.createElement('style');
      style.id = 'sfb-fix';
      style.textContent = css;
      shadow.appendChild(style);
    });
  }

  // Keep checking until the element is ready
  var interval = setInterval(function () {
    var sfb = document.querySelector('shop-follow-button');
    if (sfb && sfb.shadowRoot) {
      applyFix();
      clearInterval(interval);
    }
  }, 100);

  // Also watch for any new ones added later
  new MutationObserver(applyFix).observe(document.body, { childList: true, subtree: true });
})();

const iframe = document.getElementById("7N0P-CEO");

iframe.onload = function () {
  const doc = iframe.contentDocument || iframe.contentWindow.document;
  const style = doc.createElement("style");
  style.innerHTML = "label { color: red; }";
  doc.head.appendChild(style);
};